export default {
  generalError:
    "Lo sentimos, no pudimos completar el proceso, por favor intenta de nuevo.",
  errorTitle: "Algo salió mal",
  internalServerError:
    "Lo sentimos, ocurrió un error interno en el servidor, por favor intenta más tarde.",
  invalidServerResponse:
    "Lo sentimos, no se obtuvo una respuesta válida del servidor, por favor intenta más tarde",
};
